import type { EscalationContactFormValues } from '../types/escalationContact.types';

const MOBILE_PATTERN = /^[6-9]\d{9}$/;

export function normalizeMobileInput(value: string): string {
  return String(value || '')
    .replaceAll(/\D/g, '')
    .slice(0, 10);
}

export function isValidIndianMobile(value: string): boolean {
  return MOBILE_PATTERN.test(normalizeMobileInput(value));
}

export function formatMobileDisplay(value?: string | null): string {
  const digits = normalizeMobileInput(value || '');
  if (!digits) {
    return '—';
  }
  if (digits.length <= 5) {
    return `+91 ${digits}`;
  }
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
}

export function validateEscalationContactForm(
  values: EscalationContactFormValues
): Record<string, string> {
  const errors: Record<string, string> = {};
  const name = values.name?.trim();

  if (!name) {
    errors.name = 'Name is required';
  }

  if (!values.role) {
    errors.role = 'Role is required';
  }

  const mobile = normalizeMobileInput(values.mobileNumber);
  if (!mobile) {
    errors.mobileNumber = 'Mobile number is required';
  } else if (!MOBILE_PATTERN.test(mobile)) {
    errors.mobileNumber = 'Enter a valid 10-digit Indian mobile number';
  }

  const alternate = normalizeMobileInput(values.alternateMobileNumber);
  if (alternate && !MOBILE_PATTERN.test(alternate)) {
    errors.alternateMobileNumber = 'Enter a valid 10-digit Indian mobile number';
  }

  return errors;
}
